var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"case-item c-pointer"},[(_vm.isSelect)?_c('div',{staticClass:"select-red"}):_vm._e(),_c('div',{staticClass:"case-right"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.item.title))]),_c('div',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.item.description)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }